module.exports = __webpack_public_path__ + "static/sales-timeline-65cb2c5909ca0848025e6f89e474a37c.png";